module.exports = __webpack_public_path__ + "img/thumb_2018-05.a60002cd.jpg";